import _defineProperty from "@babel/runtime/helpers/defineProperty";

/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import classnames from 'classnames';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import PropTypes from 'prop-types';
import React from 'react';
import settings from 'carbon-components/es/globals/js/settings';
var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Horizontal Rule component.
 */

var HorizontalRule = function HorizontalRule(_ref) {
  var _classnames;

  var type = _ref.type,
      size = _ref.size,
      contrast = _ref.contrast,
      weight = _ref.weight;
  return React.createElement("hr", {
    "data-autoid": "".concat(stablePrefix, "--hr"),
    className: classnames("".concat(prefix, "--hr"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(type), type), _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(contrast), contrast), _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(size), size), _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(weight), weight), _classnames))
  });
};

HorizontalRule.propTypes = {
  /**
   * Type of HR. Choose from:
   *
   * | Name     | Description                                                                    |
   * | -------- | ------------------------------------------------------------------------------ |
   * | `solid`  | Default type variant of the horizontal rule                                   |
   * | `dashed` | Dashed/dotted type variant (type is applied in conjuction with `fluid` size) |
   */
  type: PropTypes.oneOf(['solid', 'dashed']),

  /**
   * Length of the HR. Choose from:
   *
   * | Name     | Description                                                         |
   * | -------- | ------------------------------------------------------------------- |
   * | `fluid`  | Default size variant - horizontal rule takes full width of the grid |
   * | `small`  | Shorter fixed-length variant with a max-width of 32px               |
   * | `medium` | Medium fixed-length variant with a max-width of 48px                |
   * | `large`  | Longer fixed-length variant with a max-width of 64px                |
   */
  size: PropTypes.oneOf(['fluid', 'small', 'medium', 'large']),

  /**
   * Contrast of the HR. Choose from:
   *
   * | Name              | Description                    |
   * | ----------------- | ------------------------------ |
   * | `medium-contrast` | Default contrast color variant |
   * | `low-contrast`    | Lighter contrast color variant |
   * | `high-contrast`   | Darker contrast color variant  |
   */
  contrast: PropTypes.oneOf(['medium-contrast', 'low-contrast', 'high-contrast']),

  /**
   * Weight of the HR. Choose from:
   *
   * | Name    | Description                                                                          |
   * | ------- | ------------------------------------------------------------------------------------ |
   * | `thin`  | Default weight variant                                                               |
   * | `thick` | Slightly thicker weight variant (this only applied in conjunction with `fluid` size) |
   */
  weight: PropTypes.oneOf(['thin', 'thick'])
};
export default HorizontalRule;